class NetworkService {
    constructor() {
        this.connection = null;
        this.networkType = 'unknown';
        this.effectiveType = 'unknown';
        this.downlink = 0;
        this.rtt = 0;
        this.isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;
        this.initialized = false;

        if (typeof window !== 'undefined') {
            this.init();
        }
    }

    init() {
        if (this.initialized || typeof window === 'undefined') return;
        this.initialized = true;

        this.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

        if (this.connection) {
            this.updateNetworkInfo();
            this.connection.addEventListener('change', () => this.updateNetworkInfo());
        }

        window.addEventListener('online', () => this.handleOnlineChange(true));
        window.addEventListener('offline', () => this.handleOnlineChange(false));
    }

    updateNetworkInfo() {
        if (!this.connection) return;

        this.networkType = this.connection.type || 'unknown';
        this.effectiveType = this.connection.effectiveType || 'unknown';
        this.downlink = this.connection.downlink || 0;
        this.rtt = this.connection.rtt || 0;


    }

    handleOnlineChange(online) {
        this.isOnline = online;
    }

    getNetworkInfo() {
        return {
            isOnline: this.isOnline,
            type: this.networkType,
            effectiveType: this.effectiveType,
            downlink: this.downlink,
            rtt: this.rtt,
            quality: this.getNetworkQuality()
        };
    }

    getNetworkQuality() {
        if (!this.isOnline) return 'offline';

        if (this.effectiveType === 'slow-2g') return 'very-slow';
        if (this.effectiveType === '2g') return 'slow';
        if (this.effectiveType === '3g') return 'medium';
        if (this.effectiveType === '4g') return 'fast';

        if (this.downlink < 0.5) return 'very-slow';
        if (this.downlink < 1.5) return 'slow';
        if (this.downlink < 5) return 'medium';
        return 'fast';
    }

    getReadableNetworkType() {
        const typeMap = {
            'bluetooth': 'Bluetooth',
            'cellular': this.getCellularType(),
            'ethernet': 'Ethernet',
            'none': 'No Connection',
            'wifi': 'WiFi',
            'wimax': 'WiMAX',
            'other': 'Other',
            'unknown': 'Unknown'
        };

        return typeMap[this.networkType] || 'Unknown';
    }

    getCellularType() {
        switch (this.effectiveType) {
            case 'slow-2g': return '2G (Slow)';
            case '2g': return '2G';
            case '3g': return '3G';
            case '4g': return '4G/LTE';
            default: return 'Cellular';
        }
    }

    subscribe(callback) {
        callback(this.getNetworkInfo());
        return () => { };
    }

    getPacketConfig() {
        const quality = this.getNetworkQuality();

        const configs = {
            'offline': {
                packetSize: 0,
                interval: 0,
                timeout: 0,
                enabled: false
            },
            'very-slow': {
                packetSize: 2048,
                interval: 3000,
                timeout: 60000,
                enabled: true
            },
            'slow': {
                packetSize: 5120,
                interval: 2000,
                timeout: 45000,
                enabled: true
            },
            'medium': {
                packetSize: 10240,
                interval: 1000,
                timeout: 30000,
                enabled: true
            },
            'fast': {
                packetSize: 0,
                interval: 0,
                timeout: 30000,
                enabled: false
            }
        };

        return configs[quality] || configs['medium'];
    }

    forcePacketMode() {
        return {
            packetSize: 1024,
            interval: 2000,
            timeout: 30000,
            enabled: true
        };
    }

    getAdaptiveConfig() {
        return this.getPacketConfig();
    }
}

export const networkService = new NetworkService();

